import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-hall-dialog',
  templateUrl: './manual-hall-dialog.component.html',
  styleUrls: ['./manual-hall-dialog.component.css'],
  standalone: false,
})
export class ManualHallDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly nameDialogLink: string = AppConst.ROUTING_LINK_MANUAL_NAME_DIALOG;
  readonly descDialogLink = AppConst.ROUTING_LINK_MANUAL_DESC_DIALOG;
  readonly uploaderLink: string = AppConst.ROUTING_LINK_MANUAL_UPLOADER;


  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
